import type { TaskPriority } from "@quovy/types";

import { Badge } from "../../data-display/badge";
import { PRIORITY_CLASSES, PRIORITY_LABELS } from "./task-priority";

export function TaskPriorityBadge({ priority }: { priority: TaskPriority }) {
  return (
    <Badge
      variant="outline"
      className={`rounded-full px-2 py-0.5 text-[11px] font-medium ${PRIORITY_CLASSES[priority]}`}
    >
      {PRIORITY_LABELS[priority]}
    </Badge>
  );
}
